<button mat-stroked-button class="tw-w-full tw-whitespace-nowrap" (click)="openNewFolderModal()">
  <mat-icon svgIcon="add-folder-2" />
  New Folder
</button>